<div class="back-button-container">
  <button (click)="cancelUserCreation()" class="btn btn-secondary" type="button">
    {{ 'Back' | translate }}
  </button>
</div>

<h1>
  <a class="home-link" [routerLink]="['/' + getHomePath()]">
    <i class="fa fa-home" aria-hidden="true"></i>
    <span>
      @if (isCreateMode()) {
        {{ 'Create new user' | translate }}
      } @else {
        {{ 'Edit user' | translate }}
      }
    </span>
  </a>
</h1>

<div class="overview-styling">
  <div *ngIf="loading" class="ajax_loading_wrapper">
    <div class="ajax_loading"></div>
  </div>

  <div class="container-content" fxLayout="column" fxFlex fxLayoutGap="10px">

    <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center">
      <div class="top-actions" fxFlex="45" fxFlex.xs="100" fxLayout="row" fxLayoutGap="10px"
           fxLayoutAlign="start center">
        <button type="button" class="btn btn-secondary" (click)="manageCustomer()"
                [disabled]="!(isEditMode() && getSlxUserForm().controls['customerNumber'].value)">
          {{ 'Show company of this user' | translate }}
        </button>

        <button type="button" class="btn btn-secondary" (click)="manageUsers()"
                [disabled]="!(isEditMode() && getSlxUserForm().controls['customerNumber'].value)">
          {{ 'Show other users of this users company' | translate }}
        </button>

        @if (isEditMode() && getEditableAttributes()?.personal && !isEmailAddressVerified()) {
          <button class="btn btn-info" type="button" (click)="sendVerificationLink()">
            {{ 'Send verification link' | translate }}
          </button>
        }

      </div>
    </div>

    <form [formGroup]="getSlxUserForm()" class="ng" fxLayout="column" novalidate
          (ngSubmit)="save()">

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label class="control-label" fxFlex="30">
          {{ 'Status' | translate }}
        </label>
        <div class="input-container" fxLayout="column" fxLayout.xs="column" fxFlex="70">
          <label for="active">
            <input
              type="checkbox"
              class="checkbox"
              name="active"
              id="active"
              formControlName="active"> {{ 'active' | translate }}</label>
          <label for="confirmedByAdmin">
            <input
              id="confirmedByAdmin"
              type="checkbox"
              class="checkbox"
              name="confirm"
              (change)="setStandardRolesOfCustomer($event)"
              formControlName="confirmedByAdmin"> {{ 'confirmed' | translate }}
          </label>
          <label for="emailVerified">
            <input
              id="emailVerified"
              type="checkbox"
              class="checkbox"
              name="emailVerified"
              formControlName="emailVerified"> {{ 'Email verified' | translate }}
          </label>
        </div>
      </div>

      <div class="add-customer-container" fxLayout="row" fxLayout.xs="column">
        <div fxLayout="column" fxFlex="75" fxFlex.xs="100">
          <div class="form-group column-display" fxLayout="row" fxLayout.xs="column">
            <label for="company" class="control-label" fxFlex="40">
              {{ 'Company' | translate }}
            </label>
            <div fxLayout="column" fxFlex>
              <div class="input-container">
                <input
                  type="text"
                  class="form-control"
                  formControlName="company"
                  maxlength="50"
                  id="company">
              </div>
            </div>
          </div>

          <div class="form-group column-display" fxLayout="row" fxLayout.xs="column">
            <label for="customerNumber" class="control-label" fxFlex="40">
              {{ 'Customer number' | translate }}
            </label>
            <div fxLayout="column" fxFlex>
              <div class="input-container">
                <input
                  type="text"
                  class="form-control"
                  maxlength="10"
                  formControlName="customerNumber"
                  id="customerNumber">
              </div>
            </div>
          </div>

          <div class="form-group column-display column-contact-person" fxLayout="row" fxLayout.xs="column">
            <label for="contactPerson" class="control-label" fxFlex="40">
              {{ 'Contact person' | translate }}
            </label>
            <div fxLayout="column" fxFlex>
              <div class="input-container">
                <input
                  type="text"
                  class="form-control"
                  id="contactPerson"
                  formControlName="contactPerson">
              </div>
            </div>
          </div>
        </div>

        <div class="customer-button-container" fxLayout="column" fxFlex>
          <div class="inside-form-btn-group" fxLayout="column" fxLayoutGap="16px">
            @if (getSlxUserForm().controls['customerNumber'].value || getSlxUserForm().controls['company'].value) {
              @if (getEditableAttributes()?.customer || !isEditMode()) {
                <button type="button" class="btn btn-info" (click)="changeCustomer()">
                  {{ 'Change customer' | translate }}
                </button>
                <button type="button" class="btn btn-danger" (click)="removeCustomer()">
                  {{ 'Remove customer' | translate }}
                </button>
              }
            } @else {
              <button type="button" class="btn btn-info" (click)="addCustomer()">
                {{ 'Add customer' | translate }}
              </button>
            }
          </div>
        </div>

      </div>


      <div class="add-target-group-container form-group" fxLayout="row" fxLayout.xs="column">
        <label class="control-label" fxFlex="30">
          {{ 'Target group' | translate }} *
        </label>
        <div fxLayout="column" fxFlex="45">
          <div class="input-container" fxFlex="110">
            <ng-select
              [items]="getListOfTargetGroups()"
              bindLabel="label"
              bindValue="value"
              placeholder="{{'Please select...' | translate}}"
              notFoundText="{{'No results found' | translate}}"
              formControlName="targetGroup">
            </ng-select>
          </div>
        </div>

        @if (getEditableAttributes()?.personal || !isEditMode()) {
          <div class="inside-form-btn-group" fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="space-around initial"
               fxLayoutAlign.xs="space-around center" fxFlex="25">
            <button
              type="button" class="btn btn-info" (click)="changeTargetGroup()"
              ngbTooltip="{{'If a customer is already selected, you can not change the target group. Please remove the customer in order to change the target group.' | translate}}"
              container="body"
              [disableTooltip]="!(getSlxUserForm().controls['company'].value || getSlxUserForm().controls['customerNumber'].value)"
              [disabled]="getSlxUserForm().controls['customerNumber'].value"
            >
              {{ 'Change target group' | translate }}
            </button>
          </div>
        }

      </div>

      <div class="form-group add-roles-container" fxLayout="row" fxLayout.xs="column">
        <label class="control-label" fxFlex="30">
          {{ 'Authorizations' | translate }}
        </label>
        <div class="multi-select-container" fxLayout="column" fxFlex="45">
          <div class="input-container disabled" fxFlex="90">
            <ng-select
              [items]="getRoleOptions()"
              [multiple]="true"
              bindLabel="label"
              bindValue="value"
              [clearable]="true"
              formControlName="selectedRoles">
            </ng-select>
          </div>
        </div>

        @if (getEditableAttributes()?.roles || isCreateMode()) {
          <div class="inside-form-btn-group" fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="space-around initial"
               fxLayoutAlign.xs="space-around center" fxFlex="25">
            <button type="button" class="btn btn-info"
                    id="myButton"
                    [disabled]="(!getSlxUserForm().controls['confirmedByAdmin'].value
                    || !(getSlxUserForm().controls['customerNumber'].value || getSlxUserForm().controls['targetGroup'].value))"
                    (click)="changeRoles()"
                    [tooltip]="getToolTip()"
            >
              {{ 'Change roles' | translate }}
            </button>
          </div>
        }
      </div>

      <div class="form-group column-display" fxLayout="row" fxLayout.xs="column">
        <label for="sapSalesOrganization" class="control-label" fxFlex="30">
          {{ 'SAP-Sales organization' | translate }}
        </label>
        <div fxLayout="column" fxFlex="45">
          <div class="input-container" fxFlex="90">
            <input
              type="text"
              class="form-control"
              formControlName="sapSalesOrganization"
              maxlength="50"
              id="sapSalesOrganization">
          </div>
        </div>
      </div>

      <div class="form-group column-display" fxLayout="row" fxLayout.xs="column">
        <label for="sapCompanyCode" class="control-label" fxFlex="30">
          {{ 'SAP-Company code' | translate }}
        </label>
        <div fxLayout="column" fxFlex="45">
          <div class="input-container" fxFlex="90">
            <input
              type="text"
              class="form-control"
              formControlName="sapCompanyCode"
              maxlength="50"
              id="sapCompanyCode">
          </div>
        </div>
      </div>

      <div class="form-group column-display" fxLayout="row" fxLayout.xs="column">
        <label for="sapPlant" class="control-label" fxFlex="30">
          {{ 'SAP-Plant' | translate }}
        </label>
        <div fxLayout="column" fxFlex="45">
          <div class="input-container" fxFlex="90">
            <input
              type="text"
              class="form-control"
              formControlName="sapPlant"
              maxlength="50"
              id="sapPlant">
          </div>
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="sapUserName" class="control-label" fxFlex="30">
          {{ 'SAP-Username' | translate }}
        </label>
        <div fxLayout="column" fxFlex="45">
          <div class="input-container" fxFlex="90">
            <input
              type="text"
              class="form-control"
              formControlName="sapUserName"
              maxlength="50"
              id="sapUserName">
          </div>
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="crmContactId" class="control-label" fxFlex="30">
          {{ 'CRM Contact ID' | translate }}
        </label>
        <div fxLayout="column" fxLayout.xs="column" fxFlex="45">
          <div class="input-container" fxFlex="90">
            <input
              type="text"
              class="form-control"
              id="crmContactId"
              maxlength="36"
              formControlName="crmContactId">
          </div>
          <div
            *ngIf="getSlxUserForm().controls['crmContactId'].errors && (getSlxUserForm().controls['crmContactId'].dirty || getSlxUserForm().controls['crmContactId'].touched)">
            <small [hidden]="!getSlxUserForm().controls['crmContactId'].errors.pattern" class="feedback">
              {{ 'Please enter a valid CRM Contact ID' | translate }}
            </small>
            <small [hidden]="!getSlxUserForm().controls['crmContactId'].errors.minlength" class="feedback">
              {{ 'CRM Contact ID should be at least 36 characters long' | translate }}
            </small>
          </div>
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label class="control-label" fxFlex="30">
          {{ 'Title' | translate }}
        </label>
        <div fxLayout="column" fxFlex="45">
          <div class="input-container" fxFlex="90">
            <ng-select
              [items]="getListOfTitles()"
              [searchable]="false"
              bindLabel="label"
              bindValue="value"
              placeholder="{{'Please select...' | translate}}"
              notFoundText="{{'No results found' | translate}}"
              formControlName="title">
            </ng-select>
          </div>
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="firstName" class="control-label" fxFlex="30">
          {{ 'First name' | translate }} *
        </label>
        <div fxLayout="column" fxFlex="45">
          <div class="input-container" fxFlex="90">
            <input
              type="text"
              class="form-control"
              id="firstName"
              maxlength="20"
              formControlName="firstName">
          </div>
          <div
            *ngIf="getSlxUserForm().controls['firstName'].errors && (getSlxUserForm().controls['firstName'].dirty || getSlxUserForm().controls['firstName'].touched)">
            <small [hidden]="!getSlxUserForm().controls['firstName'].errors.required" class="feedback">
              {{ 'Required' | translate }}.
            </small>
            <small [hidden]="!getSlxUserForm().controls['firstName'].errors.minlength" class="feedback">
              {{ 'It should be at least 2 characters long' | translate }}.
            </small>
          </div>
        </div>
      </div>


      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="lastName" class="control-label" fxFlex="30">
          {{ 'Last name' | translate }} *
        </label>
        <div fxLayout="column" fxLayout.xs="column" fxFlex="45">
          <div class="input-container" fxFlex="90">
            <input
              type="text"
              class="form-control"
              id="lastName"
              maxlength="40"
              formControlName="lastName">
          </div>
          <div
            *ngIf="getSlxUserForm().controls['lastName'].errors && (getSlxUserForm().controls['lastName'].dirty || getSlxUserForm().controls['lastName'].touched)">
            <small [hidden]="!getSlxUserForm().controls['lastName'].errors.required" class="feedback">
              {{ 'Required' | translate }}.
            </small>
            <small [hidden]="!getSlxUserForm().controls['lastName'].errors.minlength" class="feedback">
              {{ 'It should be at least 2 characters long' | translate }}.
            </small>
          </div>
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="email" class="control-label" fxFlex="30">
          {{ 'E-mail' | translate }} *
        </label>
        <div fxLayout="column" fxLayout.xs="column" fxFlex="45">
          <div class="input-container" fxFlex="90">
            <input
              class="form-control"
              id="email"
              maxlength="50"
              formControlName="email">
          </div>
          <div
            *ngIf="getSlxUserForm().controls['email'].errors && (getSlxUserForm().controls['email'].dirty || getSlxUserForm().controls['email'].touched)">
            <small [hidden]="!getSlxUserForm().controls['email'].errors.required" class="feedback">
              {{ 'Required' | translate }}
            </small>
            <small [hidden]="!getSlxUserForm().controls['email'].errors.pattern" class="feedback">
              {{ 'Email must have the format john.doe@example.com' | translate }}
            </small>
          </div>
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="phone" class="control-label" fxFlex="30">
          {{ 'Phone number' | translate }}
        </label>
        <div fxLayout="column" fxLayout.xs="column" fxFlex="45">
          <div class="input-container" fxFlex="90">
            <input
              type="text"
              class="form-control"
              id="phone"
              maxlength="20"
              formControlName="phone">
          </div>
          <div
            *ngIf="getSlxUserForm().controls['phone'].errors && (getSlxUserForm().controls['phone'].dirty || getSlxUserForm().controls['phone'].touched)">
            <small [hidden]="!getSlxUserForm().controls['phone'].errors.pattern" class="feedback">
              {{ 'Please enter a valid phone number' | translate }}
            </small>
          </div>
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="birthDate" class="control-label" fxFlex="30">
          {{ 'Date of birth' | translate }}
        </label>
        <div fxLayout="column" fxLayout.xs="column" fxFlex="45">
          <div class="input-container" fxFlex="90">
            <date-picker-input
              [formGroup]="getSlxUserForm()"
              formControlName="birthDate"
              [clearInput]="getEditableAttributes()?.personal"
              [calendarIcon]="getEditableAttributes()?.personal"
              ngDefaultControl>
            </date-picker-input>
          </div>
          <div
            *ngIf="getSlxUserForm().controls['birthDate'].errors && (getSlxUserForm().controls['birthDate'].dirty || getSlxUserForm().controls['birthDate'].touched)">
            <small class="feedback" [hidden]="!getSlxUserForm().controls['birthDate'].errors.ngbDate">
              {{ 'Date format must be yyyy-mm-dd' | translate }}.
            </small>
          </div>
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="postalCode" class="control-label" fxFlex="30">
          {{ 'PostalCode' | translate }}
          <span *ngIf="postalCodeRequired">*</span>
        </label>
        <div fxLayout="column" fxLayout.xs="column" fxFlex="45">
          <div class="input-container" fxFlex="90">
            <input
              type="text"
              class="form-control"
              id="postalCode"
              maxlength="10"
              formControlName="postalCode">
          </div>
          <div fxLayout="column" class="feedback-wrapper"
               *ngIf="getSlxUserForm().controls['postalCode'].errors && (getSlxUserForm().controls['postalCode'].dirty || getSlxUserForm().controls['postalCode'].touched)">
            <small [hidden]="!getSlxUserForm().controls['postalCode'].errors.required" class="feedback">
              {{ 'Required' | translate }}.
            </small>
            <small [hidden]="!getSlxUserForm().controls['postalCode'].errors.pattern" class="feedback">
              {{ 'PostalCode format not valid' | translate }}.
            </small>
          </div>
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label class="control-label" fxFlex="30">
          {{ 'Country' | translate }} *
        </label>
        <div fxLayout="column" fxLayout.xs="column" fxFlex="45">
          <div class="input-container" fxFlex="90">
            <ng-select
              [items]="getListOfCountries()"
              [minTermLength]=3
              bindLabel="label"
              bindValue="value"
              [clearable]="false"
              placeholder="{{'Please select...' | translate}}"
              notFoundText="{{'No results found' | translate}}"
              formControlName="countryCode">
            </ng-select>
          </div>
          <div
            *ngIf="getSlxUserForm().controls['countryCode'].errors && (getSlxUserForm().controls['countryCode'].dirty || getSlxUserForm().controls['countryCode'].touched)">
            <small [hidden]="!getSlxUserForm().controls['countryCode'].errors.required" class="feedback">
              {{ 'Required' | translate }}.
            </small>
          </div>
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label class="control-label" fxFlex="30">
          {{ 'Language' | translate }} *
        </label>
        <div fxLayout="column" fxLayout.xs="column" fxFlex="45">
          <div class="input-container" fxFlex="90">
            <ng-select
              [items]="getListOfLanguages()"
              [searchable]="false"
              bindLabel="label"
              bindValue="value"
              [clearable]="false"
              placeholder="{{'Please select...' | translate}}"
              notFoundText="{{'No results found' | translate}}"
              formControlName="language">
            </ng-select>
          </div>
          <div
            *ngIf="getSlxUserForm().controls['language'].errors && (getSlxUserForm().controls['language'].dirty || getSlxUserForm().controls['language'].touched)">
            <small [hidden]="!getSlxUserForm().controls['language'].errors.required" class="feedback">
              {{ 'Required' | translate }}.
            </small>
          </div>
        </div>
      </div>

      <div *ngIf="getSlxUserForm().controls['customerNumber'].value"
           class="form-group"
           fxLayout="row" fxLayout.xs="column" [ngStyle]="{'min-height': '30px'}">
        <span class="control-label" fxFlex="30"></span>
        <div fxLayout="column" fxFlex="70">
          <div class="input-container" fxFlex="70">
            <label for="customerAdmin">
              <input
                type="checkbox"
                class="checkbox"
                name="customerAdmin"
                id="customerAdmin"
                formControlName="customerAdmin"> {{ 'Customer admin' | translate }}</label>
          </div>
        </div>
      </div>

      <!--  Temporarily disabled (https://itsm.slx.de/jira/browse/UMNG-552)
            may even permanently not necessary? -->
      <!--div class="form-group" fxLayout="row" fxLayout.xs="column" [ngStyle]="{'min-height': '30px'}">
        <span class="control-label" fxFlex="30"></span>
        <div fxLayout="column" fxFlex="70">
          <div class="input-container" fxFlex="70">
            <label for="wantsNewsletter">
              <input
                type="checkbox"
                class="checkbox"
                name="wantsNewsletter"
                id="wantsNewsletter"
                formControlName="wantsNewsletter"> {{'Wants newsletter' | translate}}</label>
          </div>
        </div>
      </div-->

      @if (!isUserReadonly()) {
        <div fxLayout="column" fxLayoutGap="10px">
          <div class="bottom-actions" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center">
            <div fxFlex="45" fxFlex.xs="100" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">

              <button class="btn btn-success save-btn" type="submit"
                      [disabled]="!getSlxUserForm().controls['targetGroup'].value || !getSlxUserForm().valid">
                <div>
                  @if (isCreateMode()) {
                    {{ 'Save user' | translate }}
                  } @else {
                    {{ 'Update user' | translate }}
                  }
                </div>
              </button>

              @if (isEditMode()) {
                <app-delete-modal
                  [whichPage]="'details'"
                  [firstName]="getUser().firstName"
                  [lastName]="getUser().lastName"
                  [disabled]="!!getUser()?.crmContactId"
                  [disabledTooltip]="'User with CRM ID cannot be deleted' | translate"
                  (onHide)="deleteUser($event)">
                </app-delete-modal>
              }

            </div>
          </div>
        </div>
      }

    </form>

  </div>

</div>
<div class="divider"></div>
